import * as React from "react";
import { useTranslation } from "react-i18next";
import ProfileContainer from "../../containers/ProfileContainer";

const ProfileSummaryPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex items-center px-2 pb-4 border-gray-300">
        <div className="text-2xl font-semibold text-gray-700">
          {t("profileSummary.label.profileSummary")}
        </div>
      </div>
      <div>
      <ProfileContainer />
      </div>
    </div>
  );
};

export default ProfileSummaryPage;
